const Favorites4i = function(){	
	let init = () => {
		//remove after next release 4/10
		if(document.querySelector('.skipToCompare') && !document.querySelector('.skipToCompare').parentNode.classList.contains("hide")) 
			document.querySelector('.skipToCompare').parentNode.classList.add("hide"); 
		 
		let starRatingJS = new StarRating4i();
		starRatingJS.Init();
		
		let paging = [].slice.call(document.querySelectorAll(".pagingLinks"));
		if(paging[0]){
			paging[0].setAttribute("aria-label", "First Paging Navigation of Boards");
			paging[1].setAttribute("aria-label", "Last Paging Navigation of Boards");
		}
		
		if(document.querySelector(".boardTemplate")){
			const createBoard = new CreateNewBoard();
			createBoard.Init();
		}
		
		if(document.querySelector(".note-area")){
			const notePanels = new FavNotePanels();
			notePanels.Init();
		}
		
		let viewProdLinks = [].slice.call(document.querySelectorAll(".viewProduct"));
		for(let i = 0; i < viewProdLinks; i++){
			viewProdLinks[i].addEventListener("click", omniture.ViewProductClick);
		}
	},
	CreateNewBoard = function(){
		let init = () => {
			//only apply to the first board template with the create button
	       	document.querySelector(".boardTemplate").addEventListener("click", events);
		},
		events = e => {
			let el = e.target;
			
			if(e.target.classList.contains("create-board") && e.target.classList.contains("userLoggedIn")){
				e.preventDefault();
				getNewBoardForm(el);
			}else if(e.target.classList.contains("cancel-new-board")){
				e.preventDefault();
				cancel();
			}else if(e.target.id == "submitNewBoard"){
				e.preventDefault();
				create(el);
			}
		},
		showNewForm = () => {
			let newBoardForm = document.getElementById('newBoardForm');
			newBoardForm.classList.add('animateFadeInLeft');
			newBoardForm.classList.remove('animateSlideOutLeft', 'hide');
		},
		create = el => {
			let form = document.getElementById('newBoardForm'),
			boardName = document.getElementById('BoardName');
			
			if(form.querySelector('.ErrorMsgPanel')) form.querySelector('.ErrorMsgPanel').remove();
			
	    		if(boardName.value == ''){
	    			let response =  "Please enter a board name.";
	    			showErrorValidation(boardName, response);
	    			return false;  		
	    		}
	    		createTheBoard(el);
		},
		cancel = () => {
			let form = document.querySelector('#newBoardForm');	
			form.classList.remove('animateFadeInLeft');
			form.classList.add('animateSlideOutLeft');
			//remove board after the animation has had time to play
			setTimeout(function() {
				form.remove();
				document.querySelector('.create-board').setAttribute('aria-expanded', 'false');
				document.querySelector('.create-board').focus();
			  }, 350);
		},
		showErrorValidation = (targetEl, response) => {
			targetEl.classList.add("input-validation-error");
	    		targetEl.parentNode.querySelector(".errorMessage").textContent = response;
	    		targetEl.parentNode.querySelector(".errorMessage").classList.remove("hide");
			targetEl.focus();
		},
		hideErrorValidation = (targetEl) => {
			targetEl.classList.remove("input-validation-error");
	    		targetEl.parentNode.querySelector(".errorMessage").textContent = '';
	    		targetEl.parentNode.querySelector(".errorMessage").classList.add("hide");
		},
		getNewBoardForm = el => {
			let btn = el;
			if(document.querySelector('.boardAddedMsg')) document.querySelector('.boardAddedMsg').remove();
			
			// only fetch once
			if(document.getElementById('newBoardForm')){
				showNewForm();
				return false;
			}
                    var data = { BoardID:  "00000000-0000-0000-0000-000000000000", IsNewBoard: true };
			fetch('/favs/editboard', { 
	        		method: 'POST', 
	        		body: JSON.stringify(data), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.text() returns a promise
			}).then(function(response){
				btn.setAttribute('aria-expanded', 'true');
				btn.parentNode.parentNode.insertAdjacentHTML('beforeend', response);
				showNewForm();
	           		document.getElementById('BoardName').focus();
			});
		},
		createTheBoard = el => {
		
			let notesEl = document.getElementById('Notes');
			let nameEl = document.getElementById('BoardName');
			
			hideErrorValidation(notesEl);
			hideErrorValidation(nameEl);
			
			let boardName = nameEl.value,
			isDefaultBoard = document.getElementById('IsDefaultBoard').checked == true,
			note = notesEl.value,
			headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
			
			if(document.getElementsByClassName('boardTemplate').length == 1) isDefaultBoard = true;
			
			var data = { Name: boardName, CreatedDate: null, GURID: '', IsDefaultBoard: isDefaultBoard, Notes: note, CartID: "-1" };
			fetch('/favs/addnewboard', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(data),
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken, 'RequestVerificationToken': headerToken }
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.text() returns a promise
			}).then(function(response){
				//TODO: New Board template returned in result. Replace param e with new content to avoid page load
	            		//reload for the time being
	            		//Log new board in omniture     
	            		
	            		if(!response.success){
	            			if(response.isNotesError){	            			
	            				showErrorValidation(notesEl, response.message);
	            			} 
	            			if(response.isNameError){
	            				showErrorValidation(nameEl, response.message);
	            			}
	            			
	            		} else{
		            		omniture.LogNewBoardCreation();
	            			location.reload();
	            			return false;
	            		}

			});
		};
		
		return {
			Init: init
		};
	},
	
	//TODO
	// -- loading icons
	// -- fetch error handling
		
	FavNotePanels = function(){
		let headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value,
	
		init = () => {
			let boards = [].slice.call(document.querySelectorAll(".note-area"));
			boards.forEach(function(el){
				el.addEventListener("click", clickEvents);
			});
		},
		clickEvents = e => {
			let el = e.target;
			
			if(e.target.classList.contains("note-label") || e.target.classList.contains("edit-item-note")){
				e.preventDefault();
				showNotes(el); 
			}else if(e.target.classList.contains("remove-item-note")){
				e.preventDefault();
				removeNote(el); 
			}else if(e.target.classList.contains("submit-item-note")){
				e.preventDefault();
				saveNote(el);
			}else if(e.target.classList.contains("cancel")){
				e.preventDefault();
				hideNotes(el); 
			}
		},
		showNotes = el => {
			let noteArea = el.parentNode.parentNode.parentNode, //.note-area
			notePanel = noteArea.querySelector(".note-panel"),
			addNoteLink = noteArea.querySelector('.add-item-note'),
			editNoteLink = noteArea.querySelector('.edit-item-note'),
			noteDisplay = noteArea.querySelector('.note-display'),
			itemNote = noteArea.querySelector(".item-note");
			
	    		if(notePanel.classList.contains('hide'))
	    			showNotePanel(notePanel, addNoteLink, editNoteLink);
	    		else
	    			hideNotePanel(notePanel, addNoteLink, editNoteLink, el);
	
			if (noteDisplay.textContent != "") itemNote.value = noteDisplay.textContent; 
	 	},
	 	showNotePanel = (notePanel, addNoteLink, editNoteLink) =>{
	 		addNoteLink.setAttribute('aria-expanded', 'true');
			editNoteLink.setAttribute('aria-expanded', 'true');
			
			notePanel.classList.remove('hide');
			notePanel.querySelector('.item-note').focus();
	 	},
	 	hideNotePanel = (notePanel, addNoteLink, editNoteLink, el) => {
	    		notePanel.classList.add('hide');
			editNoteLink.setAttribute('aria-expanded', 'false');
			addNoteLink.setAttribute('aria-expanded', 'false');
			if(el) el.focus();
	 	},
	 	hideNotes = el => {
	 		let noteArea = el.parentNode.parentNode.parentNode,
	 		notePanel = el.parentNode.parentNode,
	 		addNoteLink = noteArea.querySelector('.add-item-note'),
	 		editNoteLink = noteArea.querySelector('.edit-item-note');
	 		
	 		hideNotePanel(notePanel, addNoteLink, editNoteLink);
	 		    		
	    		if(noteArea.querySelector(".note-display").textContent == "")
	    			noteArea.querySelector("button").focus();
	    		else
	    			noteArea.querySelectorAll("button")[1].focus();
	 	},
	 	addModifiedNote = noteArea => { //TODO this isn't right
	 		if(document.querySelector(".favorite-list"))
				noteArea.parentNode.querySelector(".lastModifiedDate").innerHTML = 'Item was last modified <span class="textSemiBold">today</span>';
	 		else
	 			noteArea.parentNode.parentNode.querySelector(".lastModifiedDate").innerHTML = 'Board was last modified <span class="textSemiBold">today</span>';
	 	},
	 	addNote = el => {
	 		let noteArea = el.parentNode.parentNode.parentNode, //.note-area
			noteLabel = noteArea.querySelector('.note-label'),
			notePanel = noteArea.querySelector('.note-panel'),
			editNoteLink = noteArea.querySelector('.edit-item-note'),
			removeNoteLink = noteArea.querySelector('.remove-item-note'),
			addNoteLink = noteArea.querySelector('.add-item-note'),
			noteDisplay = noteArea.querySelector('.note-display'),
			noteInput = noteArea.querySelector('.item-note');
			
			hideNotePanel(notePanel, addNoteLink, editNoteLink);
			
			noteLabel.classList.remove('hide'); 
			noteLabel.innerHTML = 'Add Notes';
			noteDisplay.innerHTML = '';
			editNoteLink.classList.add('hide');
			removeNoteLink.classList.add('hide');
			noteInput.value = "";
			addNoteLink.setAttribute('role', 'link');
			noteLabel.focus();
			 if(noteArea.parentNode.parentNode.classList.contains("boardTemplate"))
				addModifiedNote(noteArea);
	 	},
	 	showNoteHTML = (noteLabel, editNoteLink, removeNoteLink) => {
			noteLabel.classList.remove('hide');
			noteLabel.innerHTML = 'Add Notes';
	        	editNoteLink.classList.add('hide');
	        	removeNoteLink.classList.add('hide');
		},
		hideNoteHTML = (noteLabel, editNoteLink, removeNoteLink, addNoteLink) => {
	    	  	noteLabel.classList.add('hide'); 
	    	  	noteLabel.innerHTML = '';
	    	  	editNoteLink.classList.remove('hide');
	    	  	removeNoteLink.classList.remove('hide');
			addNoteLink.removeAttribute('role');
		},
	 	removeNote = el => {
	    		let boardItemID = el.parentNode.parentNode.parentNode.parentNode.querySelector('.board-item-id') ? el.parentNode.parentNode.parentNode.parentNode.querySelector('.board-item-id').value : "",
	    		data;
	    		
	    		if(boardItemID == "")
	    			data = { boardID: el.parentNode.parentNode.parentNode.parentNode.querySelector('.board-id').value, note: "", boardItemID: boardItemID };
	    		else
	    			data = { boardID: "-1" , note: "" , boardItemID : boardItemID };
	    		
			fetch('/favs/addnote', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(data), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken, 'RequestVerificationToken': headerToken }
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if(response.success == 'true')
					addNote(el);
					location.reload();
			});
		},
		saveNote = el =>{
			let noteArea = el.parentNode.parentNode.parentNode.parentNode,
			removeNoteLink = noteArea.querySelector('.remove-item-note'),
			editNoteLink = noteArea.querySelector('.edit-item-note'),
			addNoteLink = noteArea.querySelector('.add-item-note'),
			boardID = noteArea.querySelector(".board-id") ? noteArea.querySelector(".board-id").value : "",
			boardItemID = noteArea.querySelector('.board-item-id') ? noteArea.querySelector('.board-item-id').value : "",
			note = noteArea.querySelector('.item-note').value,	
			data = { BoardID: boardID, BoardItemID : boardItemID, Note: note };
			
			editNoteLink.setAttribute('aria-expanded', 'false');
			addNoteLink.setAttribute('aria-expanded', 'false');
			
			noteArea.querySelector('.errorMessage').classList.add('hide');
			noteArea.querySelector('.errorMessage').innerHTML = '';
			
			if (addNoteLink.value.length > 0) addNoteLink.classList.add('hide'); 
			
			fetch('/favs/addnote', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(data), 
	        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken, 'RequestVerificationToken': headerToken }
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				let noteLabel = noteArea.querySelector('.note-label'),
				notePanel = noteArea.querySelector('.note-panel');
	
		 		if(response.success == 'true'){
		 			noteArea.querySelector('.note-display').innerHTML = note;
		 			
		 			if(note == ''){
						showNoteHTML(noteLabel, editNoteLink, removeNoteLink);
						addNoteLink.focus();
					}else{
						hideNoteHTML(noteLabel, editNoteLink, removeNoteLink, addNoteLink);
						editNoteLink.focus();
					}
					
			     		notePanel.classList.add('hide');
			     		
					if(noteArea.parentNode.parentNode.querySelector(".lastModifiedDate")) addModifiedNote(noteArea);
	 			} else {	 			
	 				noteArea.querySelector('.errorMessage').classList.remove('hide');
					noteArea.querySelector('.errorMessage').innerHTML = response.message;
	 			}
	
				
			});
		};
		
		return {
			Init: init
		};
	},
	omniture = (function () {
		let logNewBoardCreation = () => {
			const account = typeof s_account === 'string' ? s_account : '4imprintprod';
			const s = typeof s_gi === 'function' ? s_gi(account) : '';
			if (s) {
			  s.linkTrackVars = 'prop26';
			  s.linkTrackEvents = 'None';
			  s.prop26 = "Fav Board Creations";//New board, log create event
			  s.tl(true, 'o', 'Fav Board Creations');
			}
		};
		let viewProductClick = () => {
			const account = typeof s_account === 'string' ? s_account : '4imprintprod';
			const s = typeof s_gi === 'function' ? s_gi(account) : '';
			if (s) {
		  		s.linkTrackVars = 'eVar36';
		  		s.linkTrackEvents = 'none';
		 		s.eVar36 = "Fav Boards Conversions";//Product click event variable expires at purchase
		  		s.tl(true, 'o', 'Fav Boards Conversions');
			}
	    	};
		return {
			LogNewBoardCreation: logNewBoardCreation,
			ViewProductClick: viewProductClick
		};
	})();
	
	return {
		Init: init
	};
};

(function(){
	const favoritesPage = new Favorites4i();
	favoritesPage.Init();
})();